import ActionBtn from "@/components/ActionBtn";
import {
  ReportContent,
  ReportHeader,
  ReportSearch,
} from "@/components/tableDrawer";
import { ColumnsGenerator } from "@/utils/tableUtils";
import { useMemo, useRef, useState } from "react";
import { getAccountManagersBrokers } from "@/api/endpoints/AccountManager/AccountManagersBrokersSettings";
import SelectACMPopup from "./popups/SelectACMPopup";

const BrokersRequests = () => {
  const selectACMPopupRef = useRef(null);
  const [selectedBroker, setSelectedBroker] = useState(null);

  const columns = useMemo(
    () => [
      ColumnsGenerator.CustomCell("id", (original) => `#${original?.brokerId}`),
      ColumnsGenerator.SearchableTextCell("brokerName", "brokerName"),
      ColumnsGenerator.SearchableTextCell("accountManagerName", "accountManagerName"),
      ColumnsGenerator.CustomCell("action", (original) => {
        const isDisabled = original?.accountManagerName;
        return (
            <ActionBtn title="assign-acm" onApply={() => openSelectACMPopup(original)} className="btn-accept" isDisabled={isDisabled}/>
        );
      }),
    ],
    [],
  );

  const openSelectACMPopup = (data) => {
    setSelectedBroker(data);
    selectACMPopupRef.current.click();
  };

  return (
    <>
      <SelectACMPopup modalID={selectACMPopupRef} selectedBroker={selectedBroker} />
      <ReportContent tableAPI={getAccountManagersBrokers} stickyActions={true} columns={columns} >
        <ReportHeader>
          <ReportSearch />
        </ReportHeader>
      </ReportContent>
    </>
  );
};

export default BrokersRequests;
